export const groupTabs = [
  "participantes",
  "eventos",
  "materiais",
  "ranking"
];
